import { colours } from 'bz-core-controls/styles/colours';
import React from 'react';

class Label extends React.Component {
  static style = { color: colours.lightBlue, fontSize: 16 };

  get show() {
    return !this.props.hideLabel && this.props.isMarkdown;
  }

  render() {
    if (!this.show) {
      return null;
    }

    return <label style={Label.style}>{this.props.label}</label>;
  }
}

export default Label;
